import axios from 'axios';

const PUBLIC_PATHS = ['/login', '/recuperar-senha', '/senha/recuperar', '/primeiro-acesso', '/registrar', '/confirmar-cadastro', '/app', '/ios_app', '/cadastro/aprovar'];

function isPublicPath(pathname: string): boolean {
  return PUBLIC_PATHS.some((path) => pathname === path || pathname.startsWith(`${path}/`));
}

/**
 * Instância do Axios configurada para chamar a API do backend Rails.
 * 
 * Usa cookies/sessão do Rails (não Bearer token).
 * withCredentials: true permite que cookies sejam enviados nas requisições.
 */
const api = axios.create({
  baseURL: '',
  headers: {
    'Accept': 'application/json',
    'Content-Type': 'application/json',
  },
  withCredentials: true, // Importante: permite envio de cookies de sessão
});

// Interceptor para tratar respostas de erro
api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error.response?.status;
    const requestUrl = error.config?.url || '';
    const currentPath = window.location.pathname;
    const isInPublicRoute = isPublicPath(currentPath);
    
    // Não redireciona para login se já estiver na página de login
    // ou se for verificação de sessão OAuth (401 é esperado nesses casos)
    const isLoginRequest = requestUrl.includes('/entrar');
    const isSessionCheck = requestUrl.includes('/condomino/me');

    // Em rotas públicas, cada página trata o erro localmente sem redirecionamento global.
    if (isInPublicRoute) {
      return Promise.reject(error);
    }

    if (status === 401 && !isLoginRequest && !isSessionCheck) {
      window.location.href = '/login';
    } else if (status === 403) {
      // Acesso não permitido
      window.location.href = '/403';
    } else if (status === 503) {
      // Serviço indisponível
      window.location.href = '/503';
    } else if (status >= 500) {
      // Erro interno do servidor
      window.location.href = '/500';
    }
    
    return Promise.reject(error);
  }
);

export default api;
